module["exports"] = [
  "###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/building_number.js
// module id = 1613
// module chunks = 0